import {Component, HostListener, inject, OnDestroy, ViewEncapsulation} from '@angular/core';
import {BehaviorSubject, ObservableInput, of, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, switchMap} from 'rxjs/operators';
import {BaseCellEditorComponent} from '../base-cell-editor/base-cell-editor.component';
import {ITableVerticalDataRow} from "../../table-vertical-api-adapter";
import {IApiRow} from 'frontier/browserkit';
import {MatOption} from '@angular/material/core';
import {AsyncPipe, NgFor} from '@angular/common';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {MatFormField} from '@angular/material/form-field';
import { ControlService } from 'frontier/nucleus';

@Component({
  selector: 'kpi4me-autocomplete-editor',
  templateUrl: './autocomplete-editor.component.html',
  styleUrls: ['./autocomplete-editor.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    MatAutocompleteTrigger,
    ReactiveFormsModule,
    MatAutocomplete,
    NgFor,
    MatOption,
    AsyncPipe,
  ],
})
export class AutocompleteEditorComponent extends BaseCellEditorComponent implements OnDestroy {
  private _controlService = inject(ControlService);
  filteredEntities = new BehaviorSubject<any>([]);
  subs = new Subscription();
  entities: any[] = [];
  displayWith = (value: any) => {
    if (value) {
      return typeof value === 'string' ? value : value.name;
    }
  };
  edited = false;

  @HostListener('keydown.enter', ['$event'])
  override onEnter(event: KeyboardEvent) {
    // if (this.edited) {
    //   this.onOptionSelected()
    // }
  }

  @HostListener('focusout', ['$event'])
  override onBlur() {
    // if (this.edited) {
    //   this.onOptionSelected()
    // }
  }

  private entitiesSub: Subscription;

  override set row(r: ITableVerticalDataRow) {
    super.row = r;
    // Replace the previous stream instead of accumulating one subscription per row
    // assignment — each of them would fire its own lookup request per keystroke.
    this.entitiesSub?.unsubscribe();
    this.entitiesSub = this.formControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      // switchMap: a new keystroke cancels the previous lookup so responses cannot arrive
      // out of order and overwrite newer suggestions.
      switchMap((value: string): ObservableInput<{apiRow: object; name: string}[] | null> => {
        return value ? this.getEntities(value) : []
      }),
    ).subscribe((entities: {apiRow: object; name: string}[] | null): void => {
      this.filteredEntities.next(entities);
    });
    this.subs.add(this.entitiesSub);
  }

  override get row(): ITableVerticalDataRow {
    return super.row;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onOptionSelected(): void {
    this.edited = false;
    const data: {
      client: any, location?: string, district?: string, postcode?: string, city?: any
    } = {
      client: this.row.apiRow.obj,
    }
    if (typeof this.formControl.value === 'string') {
      data[this.row.attribute as 'location' | 'district' | 'postcode'] = this.formControl.value;
    } else {
      data.city = this.formControl.value;
    }
    this._controlService.controlPostExecuteAction({
        _parameters: [
          this.row.apiInstance.instanceid,
          'setcity',
          data]
      }
    ).subscribe((res: object) => {
      const apiRow = res as IApiRow;
      this.cellChanged.emit({verticalRow: this.row, apiRow});
    });
  }

  getEntities(filterValue: string) {
    if (typeof filterValue !== 'string') {
      return of([]);
    }
    return this._controlService.controlPostExecuteAction({
        _parameters: [
          this.row.apiInstance.instanceid,
          'getcity',
          {
            [this.row.attribute]: filterValue
          }
        ]
      }
    ).pipe(map((rows: object) => {
      if (typeof rows === 'string') {
        return [];
      } else if (rows) {
        return (rows as any[]).map(r => {
          return {
            apiRow: r,
            name: r.name,
          }
        })
      }
      return null
    }))
  }

  sendCustomValue(): void {
    //this.onOptionSelected();
  }
}
